import { useCallback, useEffect, useState } from 'react';

/**
 * Bearing / pitch del mapa para MapControls (brújula y reset vista cenital).
 * @param {React.MutableRefObject} mapInstanceRef
 * @param {boolean} mapActive — true cuando el mapa ya está instanciado (p. ej. mapInfo.zoom definido)
 */
export function useMapOrientation(mapInstanceRef, mapActive = false) {
  const [mapBearing, setMapBearing] = useState(0);
  const [mapPitch, setMapPitch] = useState(0);

  useEffect(() => {
    if (!mapActive) return undefined;

    const map = mapInstanceRef.current;
    if (!map) return undefined;

    const sync = () => {
      setMapBearing(map.getBearing());
      setMapPitch(map.getPitch());
    };

    sync();
    map.on('move', sync);
    map.on('rotate', sync);
    map.on('pitch', sync);

    return () => {
      map.off('move', sync);
      map.off('rotate', sync);
      map.off('pitch', sync);
    };
  }, [mapInstanceRef, mapActive]);

  const handleResetNorth = useCallback(() => {
    const map = mapInstanceRef.current;
    if (!map) return;
    map.easeTo({
      bearing: 0,
      duration: 400,
    });
  }, [mapInstanceRef]);

  const handleResetPitch = useCallback(() => {
    const map = mapInstanceRef.current;
    if (!map) return;
    map.easeTo({
      pitch: 0,
      duration: 400,
    });
  }, [mapInstanceRef]);

  return {
    mapBearing,
    mapPitch,
    handleResetNorth,
    handleResetPitch,
  };
}
